import React, { LazyExoticComponent } from 'react'
import { ErrorBoundary } from '@hotmart/hub-components'

type PropsPrivateRoute = {
  sentryTag: { name: string; release: string }
  element?: LazyExoticComponent<React.ComponentType<any>>
}

function PublicRoute(props: PropsPrivateRoute) {
  const Component = props.element

  return (
    <ErrorBoundary sentryTag={props.sentryTag}>
      <Component {...props} />
    </ErrorBoundary>
  )
}
export default PublicRoute
